import React, { forwardRef } from 'react';

export const Button = forwardRef(({children, className, mods = [], variant='primary', ...props}, ref) => {
  return (
    <button 
      className={`btn ${variant ? `btn--${variant}` :''} ${mods.map(m => ` btn--${m}`)} ${className ? className : ''}`} 
      ref={ref}
      {...props}
    >
      {children}
    </button>
  )
})